<script lang="ts">
  import { defineComponent } from "vue";
  import { Modules, Fiches, Sections } from '@/generated/classes/AppSchema';
  import Route from '@/generated/classes/Route';
  import Document, { ObjType } from '@/generated/classes/Document';
  import Owner from '@/generated/classes/Owner';
  import NotifSections from "@/generated/sections/NotifSections.vue";
  import { Ressources } from '@/framework/base/helpers/Ressources';
  import AdminAttrib from '@/generated/classes/AdminAttrib';
  import Admin from '@/generated/classes/Admin';
  import Ressource, { type RessourceUpdated } from '@/framework/ressource/classes/Ressource';
  import Section from '@/framework/base/classes/Section';
  import { goToModule } from '@/framework/base/helpers/NavHelper';
  import SectionDialog from '@/custom/sections/SectionDialog.vue';
  import SectionAdmin from '@/framework/admin/components/SectionAdmin.vue';
  import SectionPrelevMeans from '@/extend/sections/SectionPrelevMeansExtend.vue';
  import SectionRib from '@/extend/sections/SectionRibExtend.vue';
  import SectionGraphDialog from '@/custom/sections/SectionGraphDialog.vue';
  import SectionGestionnairesPaie from "@/custom/sections/SectionGestionnairesPaie.vue";
  import SectionApprentiList from '@/extend/sections/SectionApprentiListExtend.vue';
  import SectionEtablissementAffiliations from '@/extend/sections/SectionEtablissementAffiliationsExtend.vue';
  import SectionSubscription from "@/custom/sections/SectionSubscription.vue";
  import {
    storeEtablissement,
    storeContrat,
    storePaie,
    storeCreneau,
    storeRib,
    storeFractionDsn,
    storeDocument
  } from "@/generated/stores";
  import CreneauxEditor from '@/custom/sections/CreneauxEditor.vue';
  import SectionContratViewer from '@/custom/sections/SectionContratViewer.vue';
  import SectionPaieViewer from '@/custom/sections/SectionPaieViewer.vue';
  import SectionDocumentViewer from "@/custom/sections/SectionDocumentViewer.vue";
  import SectionImportStatus from '@/custom/sections/SectionImportStatus.vue';
  import SectionImportDoc from '@/custom/sections/SectionImportDoc.vue';
  import SectionDefineMetaAttrib from '@/framework/metaAttrib/components/SectionDefineMetaAttrib.vue';
  import SectionValuateMetaAttrib from '@/framework/metaAttrib/components/SectionValuateMetaAttrib.vue';
  import AdminInfo from '@/generated/classes/AdminInfo';
  import SectionFractionDsn from '@/extend/sections/SectionFractionDsnExtend.vue';
  import SectionRemuneration from '@/custom/sections/SectionRemuneration.vue';
  import SectionMandatViewer from '@/custom/sections/SectionMandatViewer.vue';
  import SectionCartItemList from '@/custom/sections/SectionCartItemList.vue';
  import { useRouter } from "vue-router";
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import SectionContratSalarie from "@/custom/sections/SectionContratSalarie.vue";
  import SectionCgu from "@/custom/sections/SectionCgu.vue";
  import SectionRapprochement from "@/custom/sections/SectionRapprochement.vue";
  import SectionContratListExtend from "@/extend/sections/SectionContratListExtend.vue";

  export let ressourceAttrib: AdminAttrib[] = [];
  export let dialogAttrib: AdminAttrib[] = [];

  export function loadAttrib() {
    if (ressourceAttrib.length == 0) {
      Admin.loadAttribs('Ressources').then((attribs) => {
        ressourceAttrib = [];
        attribs.forEach(a => ressourceAttrib.push(a));
      }).catch((err) => {
        console.log(err);
      });
    }
    if (dialogAttrib.length == 0) {
      Admin.loadAttribs('Dialogs').then((attribs) => {
        dialogAttrib = [];
        attribs.forEach(a => dialogAttrib.push(a));
      }).catch((err) => {
        console.log(err);
      });
    }
  };

  export default defineComponent({
    components: {},
    extends: NotifSections,
    data () {
      const data: Section = new Section();
      const lastData: Section = this.section;
      return {
        dialogOpen: false,
        ressourceAttrib,
        dialogAttrib,
        lastData,
        data,
        router: useRouter()
      };
    },
    watch: {
      route: {
        handler (newRoute, oldRoute) {
          if (newRoute !== oldRoute) {
            this.checkDialogState(newRoute, oldRoute);
          }
        },
        immediate: true,
      },
      data: {
        handler (newData, oldData) {
          if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
            //this.checkDialogState(newData, oldData);
          }
        },
        immediate: true,
      },
    },


    methods: {

      checkDialogState(newRouteOrData: any, oldRouteOrData: any) {
        if (newRouteOrData === oldRouteOrData) return;
        this.setRoute();
        const dialog = this.fillExtraData(this.route);
        if (this.route.isDialog || dialog) {
          if (!this.dialogOpen) {
            this.dialogOpen = true;
          }
        } else {
          if (this.dialogOpen) {
            this.dialogOpen = false;
          }
          goToModule(this.router, this.route);
          this.closeDialog();
        }
      },
      setRoute () {
        if (this.lastRoute !== this.route) {
          this.lastRoute = this.route;
        }
        this.fillData(this.route);
        this.data = this.section;
      },
      fillExtraData (route: Route): boolean {
        let res = false;
        if (route.section == Sections.CONTRAT_VIEWER || route.section == Sections.PAIE_VIEWER || route.section == Sections.DOCUMENT_VIEWER) {
          this.fullscreen = true;
        } 
        if (route.section == Sections.DIALOG) {
          this.section = new Section();
          this.section.component = SectionDialog;
          this.section.type = 'dialogue';
          this.section.data = this.route.attribut;
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.ADMIN_RESOURCE) {
          const ressource = Ressources.getById(route.sectionObjId);
          if (ressource.id > 0) {
            ressource.updated = route.attribut as RessourceUpdated;
            this.section = new Section();
            this.section.component = SectionAdmin;
            this.section.type = 'data';
            this.section.data = ressource;
            this.section.propType = 'config';
            this.section.propData = ressourceAttrib;
            const adminInfo = new AdminInfo();
            adminInfo.hasHtmlMobile = true;
            this.section.adminInfo = adminInfo;
            this.fullscreen = false;
            this.section.showButton = true;
            res = true;
          }
        } else if (route.section == Sections.GRAPH_DIALOG) {
          this.section = new Section();
          this.section.component = SectionGraphDialog;
          this.section.type = 'graphData';
          this.section.showButton = true;
          this.section.data = this.route.attribut;
          res = true;
        } else if (route.section == Sections.SUBSCRIPTION) {
          this.section = new Section();
          this.section.component = SectionSubscription;
          this.section.owner = route.data;
          this.section.type = "subscriptionRequired";
          this.section.data = route.attribut;
          this.fullscreen = false;
          this.midSize = true;
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.GESTIONNAIRES_PAIE && route.ficheObjId != null && route.ficheObjId > 0) {
          this.section = new Section();
          this.section.component = SectionGestionnairesPaie;
          const etablissement = storeEtablissement.getEtablissement(route.ficheObjId);
          this.section.data = etablissement;
          this.section.type = 'etablissement';
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.APPRENTI_LIST && route.ficheObjId != null && route.ficheObjId > 0) {
          this.section = new Section();
          this.section.component = SectionApprentiList;
          const etablissement = storeEtablissement.getEtablissement(route.ficheObjId);
          this.section.data = etablissement;
          this.section.type = 'etablissement';
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.CRENEAUX && route.ficheObjId != null && route.ficheObjId > 0) {
          this.section = new Section();
          this.section.component = CreneauxEditor;
          const contrat = storeContrat.getContrat(route.ficheObjId);
          this.section.type = 'contrat';
          this.section.data = contrat;
          this.section.propType = 'creneaux'
          if (route.sectionObjId != null && route.sectionObjId > 0) {
            this.section.propData = [storeCreneau.getCreneau(route.sectionObjId)];
          } else {
            this.section.propData = [];
          }
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.IMPORT_DOC && route.attribut != null) {
          this.section = new Section();
          this.section.component = SectionImportDoc;
          this.section.type = 'document';
          this.section.data = Document.fromJson(route.attribut as Document);
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.IMPORT_STATUS && route.ficheObjId != null && route.ficheObjId != 0) {
          const etablissement = storeEtablissement.getEtablissement(route.ficheObjId);
          if (etablissement.id > 0) {
            this.section = new Section();
            this.section.component = SectionImportStatus;
            this.section.type = 'etablissement';
            this.section.data = etablissement;
            this.fullscreen = false
            this.section.showButton = true;
            res = true;
          }
        } else if (route.section == Sections.DEFINE_META_ATTRIB) {
          this.section = new Section();
          this.section.component = SectionDefineMetaAttrib;
          this.section.type = 'metaAttrib';
          this.section.data = this.route.attribut;
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.VALUATE_META_ATTRIB) {
          this.section = new Section();
          this.section.component = SectionValuateMetaAttrib;
          this.section.type = 'metaAttribs';
          this.section.data = this.route.attribut;
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.EXTERN_URL) {
          const url = this.route.attribut as string;
          const target = this.route.ficheObjId == 0 ? '_self' : '_blank';
          window.open(url, target);
        } else if (route.fiche == Fiches.PROJET_CONTRATS && route.section == Sections.CONTRAT && route.ficheObjId != null && route.ficheObjId > 0) {
          const contrat = storeContrat.getContrat(route.ficheObjId);
          if (contrat.id > 0) {
            this.section = new Section();
            this.section.component = SectionContratViewer;
            this.section.type = 'contrat';
            this.section.data = contrat;
            this.fullscreen = true;
            this.section.showButton = true;
            res = true;
          }
        } else if (route.fiche == Fiches.PROJET_CONTRATS && route.section == Sections.CONTRAT_VIEWER && route.sectionObjId != null && route.sectionObjId > 0) {
          const contrat = storeContrat.getContrat(route.sectionObjId);
          if (contrat.id > 0) {
            this.section = new Section();
            this.section.component = SectionContratViewer;
            this.section.type = 'contrat';
            this.section.data = contrat;
            this.fullscreen = true;
            this.section.showButton = true;
            res = true;
          }
        } else if (route.fiche == Fiches.NONE && route.section == Sections.DOCUMENT_VIEWER && route.sectionObjId != null && route.sectionObjId > 0) {
          const document = storeDocument.getDocument(route.sectionObjId);
          if (document.id > 0) {
            this.section = new Section();
            this.section.component = SectionDocumentViewer;
            this.section.type = 'document';
            this.section.data = document;
            this.fullscreen = true;
            this.section.showButton = true;
            res = true;
          }
        } else if (route.section == Sections.PRELEV_MEANS && route.ficheObjId != null && route.ficheObjId > 0) {
          this.section = new Section();
          const etablissement = storeEtablissement.getEtablissement(route.ficheObjId);
          if (etablissement.id > 0) {
            this.section.component = SectionPrelevMeans;
            this.section.type = 'etablissement';
            this.section.data = etablissement;
            this.section.propType = 'owner';
            this.section.propData = route.data;
            this.fullscreen = false
            this.section.showButton = true;
            res = true;
          }
        } else if (route.section == Sections.CONTRAT_SALARIE && (route.ficheObjId || route.sectionObjId)) {
          const contrat = storeContrat.getContrat(route.ficheObjId ? route.ficheObjId : route.sectionObjId);
          this.section = new Section();
          this.section.component = SectionContratSalarie;
          this.section.type = 'contrat';
          this.section.data = contrat;
          this.fullscreen = false
          this.section.showButton = true;
          this.showMissing = false;
        } else if (route.section == Sections.MANDAT_VIEWER && route.sectionObjId) {
          const document = storeDocument.getDocument(route.sectionObjId);
          this.section = new Section();
          this.section.component = SectionMandatViewer;
          this.section.type = 'document';
          this.section.data = document;
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.RIB && route.data != null) {
          this.section = new Section();
          const rib = storeRib.createNewRib();
          rib.owner = route.data as Owner;
          this.section.component = SectionRib;
          this.section.type = 'rib';
          this.section.data = rib;
          this.fullscreen = false
          this.section.showButton = true;
          res = true;
        } else if (route.section == Sections.ETABLISSEMENT_AFFILIATIONS && route.sectionObjId != null && route.sectionObjId > 0) {
          this.section = new Section();
          const etablissement = storeEtablissement.getEtablissement(route.sectionObjId);
          if (etablissement.id > 0) {
            this.section.component = SectionEtablissementAffiliations;
            this.section.type = 'etablissement';
            this.section.data = etablissement;
            this.fullscreen = false
            this.section.showButton = true;
          }
          res = true;
        } else if (route.section == Sections.FRACTION_DSN && route.ficheObjId) {
          this.section = new Section();
          this.section.component = SectionFractionDsn;
          this.section.type = 'fractionDsn';
          this.section.data = storeFractionDsn.getFractionDsn(0);
          this.section.data.fromFractionDsn(route.attribut);
          this.section.data.etablissementId = route.ficheObjId;
          this.section.propType = 'etablissement';
          this.section.propData = storeEtablissement.getEtablissement(route.ficheObjId);
          this.fullscreen = false
          this.section.showButton = true;
          this.showMissing = false;
          res = true;
        } else if (route.section == Sections.REMUNERATION && route.ficheObjId) {
          const paie = storePaie.getPaie(route.ficheObjId);
          const contrat = storeContrat.getContrat(paie.contratId);
          this.section = new Section();
          this.section.component = SectionRemuneration;
          this.section.type = 'contrat';
          this.section.data = contrat;
          this.section.propType = 'paie';
          this.section.propData = paie;
          this.fullscreen = false
          this.section.showButton = true;
          this.showMissing = false;
          res = true;
        } else if (route.section == Sections.CART_ITEM_LIST && route.ficheObjId > 0) {
          this.section = new Section();
          this.section.component = SectionCartItemList;
          this.section.type = 'etablissementId';
          this.section.data = route.ficheObjId;
          this.fullscreen = false;
          this.section.showButton = true;
          this.showMissing = false;
          res = true;
        } else if (route.section == Sections.CGU) {
          this.section = new Section();
          this.section.component = SectionCgu;
          this.fullscreen = false
          this.showMissing = false;
          res = true;
        } else if (route.section == Sections.RAPPROCHEMENT) {
          this.section = new Section();
          this.section.component = SectionRapprochement;
          this.section.type = 'transaction';
          this.section.data = route.data;
          this.fullscreen = true
          this.showMissing = false;
          res = true;
        } else if (route.section == Sections.CONTRAT_LIST) {
          const section2 = new Section();
          section2.component = SectionContratListExtend;
          section2.fullscreen = true;
          route.data = section2;
          res = false;
        }

        if (route.requiredAttributs.length > 0) {
          this.section.requiredAttributs = route.requiredAttributs;
        }

        return res;
      },
      dataUpdated (data: any): void {
        if (this.route.fiche == Fiches.NONE && this.route.section == Sections.ADMIN_RESOURCE) {
          const ressource = new Ressource();
          ressource.fromRessource(data);
          Ressources.update(ressource);
        }
      },
      saved () {
        if (this.route.pdfNotif) {
          Document.updatePdf(this.route.pdfNotif);
        }
      }
    }
  })

</script>
